export const environment = {
  production: false,
  urlAngular: "https://test-one.pichincha.com/app",
}; 